import delve from 'dlv'
import type { FC } from 'react'
import { getNamedPageStaticProps } from 'lib/staticProps'

import Head from 'next/head'
import Layout from 'components/layouts/minimal'
import InstallSuccessPage from 'components/pages/install-success'

interface Props {
  content: any
}

const InstallSuccess: FC<Props> = ({ content }) => {
  const { title } = delve(content, 'data.attributes')
  return (
    <>
      <Head>
        <title>{title}</title>
      </Head>
      <Layout>
        <InstallSuccessPage content={content} />
      </Layout>
    </>
  )
}

export const getStaticProps = getNamedPageStaticProps(
  'install-success',
  'blocks.installation-successful'
)

export default InstallSuccess
